/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestUpsertEmployerNetwork } from '../model/models';
import { ApiResponseEmployerNetwork } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface EmployerNetworkUpdateServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestUpsertEmployerNetwork 
     */
    employerNetworkUpdateControllerUpsert0(apiRequestUpsertEmployerNetwork: ApiRequestUpsertEmployerNetwork, extraHttpRequestParams?: any): Observable<ApiResponseEmployerNetwork>;

    /**
     * 
     * 
     * @param apiRequestUpsertEmployerNetwork 
     */
    employerNetworkUpdateControllerUpsert1(apiRequestUpsertEmployerNetwork: ApiRequestUpsertEmployerNetwork, extraHttpRequestParams?: any): Observable<ApiResponseEmployerNetwork>;

}
